import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NuevaTasacion from './pages/NuevaTasacion';
import Comparables from './pages/Comparables';
import Resultado from './pages/Resultado';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/nueva-tasacion" element={<NuevaTasacion />} />
        <Route path="/comparables/:id" element={<Comparables />} />
        <Route path="/resultado/:id" element={<Resultado />} />
      </Routes>
    </BrowserRouter>
  );
}
